import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { BRAND } from "../../data/zingly";

const PLATFORMS = [
  {
    name: "Swiggy",
    tagline: "Lightning-fast doorstep delivery",
    color: "#fc8019",
    bg: "from-[#fc8019] to-[#e06b00]",
    url: BRAND.swiggyUrl,
    logo: "🛵",
  },
  {
    name: "Zomato",
    tagline: "Hot, fresh & on time",
    color: "#cb202d",
    bg: "from-[#cb202d] to-[#a01620]",
    url: BRAND.zomatoUrl,
    logo: "🍽️",
  },
];

export const OrderPlatforms = () => {
  return (
    <section
      data-testid="platforms-section"
      className="relative py-24 md:py-28 bg-[#FFF8F1] overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-14"
        >
          <div className="inline-block text-xs uppercase tracking-[0.3em] text-[#F58220] font-semibold mb-3">
            Quick Order
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-extrabold text-[#1E1E1E]">
            Order From Your Favorite Platform
          </h2>
          <p className="mt-5 text-base md:text-lg text-[#555555] max-w-2xl mx-auto">
            Get Zingly Dosa delivered to your doorstep in minutes.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-7">
          {PLATFORMS.map((p, i) => (
            <motion.a
              key={p.name}
              href={p.url}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.15, duration: 0.7 }}
              whileHover={{ y: -10, rotateX: 4, rotateY: -4 }}
              style={{ transformStyle: "preserve-3d", perspective: "1200px" }}
              className={`group relative overflow-hidden rounded-3xl p-8 md:p-10 bg-gradient-to-br ${p.bg} text-white shadow-[0_20px_50px_-15px_rgba(0,0,0,0.3)] hover:shadow-[0_30px_70px_-15px_rgba(0,0,0,0.45)] transition-shadow`}
              data-testid={`platform-card-${p.name.toLowerCase()}`}
            >
              <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-white/10 blur-3xl pointer-events-none" />
              <div className="relative flex items-start justify-between">
                <div className="text-6xl drop-shadow-lg">{p.logo}</div>
                <div className="w-12 h-12 rounded-full bg-white/15 backdrop-blur flex items-center justify-center group-hover:bg-white/25 transition">
                  <ArrowUpRight className="w-5 h-5" />
                </div>
              </div>
              <div className="relative mt-10">
                <div className="text-xs uppercase tracking-[0.3em] opacity-80">Order on</div>
                <h3 className="font-serif text-4xl md:text-5xl font-extrabold mt-2">{p.name}</h3>
                <p className="mt-3 text-white/90 text-[15px]">{p.tagline}</p>
              </div>
              <div className="relative mt-8 inline-flex items-center gap-2 text-sm font-semibold border-b-2 border-white/40 pb-1 group-hover:border-white transition">
                Open {p.name}
                <ArrowUpRight className="w-4 h-4" />
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};
